import dayjs from 'dayjs';

import { getPastWMTWeekDateRange, getWMTWeekToDate } from './walmart-week';

const isSaturday = dayjs().day() === 6;

export { getPastWMTWeekDateRange, getWMTWeekToDate, isSaturday };
